import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* setEmsRegTailNumberOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getEMSRegTailNumberOptions])
    const { entity } = response
    yield put(actions.setEmsRegTailNumberOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setEmsRegTailNumberOptions() error: ${e}`))
  }
}
export function* setEmsRegTailNumberOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setEmsRegTailNumberOptions)
}
